import React from "react";

export default function Input({
  id,
  label,
  error,
  placeholder,
  borderColor,
  className,
  props,
  required,
  field_name,
  onChange,
  onBlur,
  setActiveElement,
}) {
  const idRef = React.useRef(id || randomId());

  return (
    <div className={`relative text-base font-normal items-center ${className}`}>
      <input
        id={idRef.current}
        name={field_name}
        placeholder={placeholder || label}
        autoComplete="off"
        onFocus={() => setActiveElement(field_name)}
        {...props}
        className={`peer border h-12 w-full disabled:opacity-60 ${
          error ? "!text-red-600" : "!text-gray-800"
        } pl-6 pr-2 py-2 bg-white text-md
          font-medium rounded-lg placeholder-transparent  outline-none ${
            error ? "ring-err-base" : ""
          } input-invalid`}
        style={{ borderColor: error ? "#dc2626" : borderColor }}
        onChange={(e) => {
          onChange(field_name, e.target.value);
          setActiveElement(field_name);
        }}
        onBlur={(e) => {
          onBlur(field_name, e.target.value);
        }}
      />
      <label
        htmlFor={idRef.current}
        className="
          absolute rounded-lg text-xs bg-white left-0 -top-2 ml-4 pt-1 px-2
          peer-focus:text-xs text-gray-400 peer-focus:peer-valid::text-prm-base peer-focus:text-prm-base
          peer-focus:-top-2 transition-all 
          peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-3
          peer-placeholder-shown:text-md
          label-invalid
        "
      >
        {label}
        {required && <span>*</span>}
      </label>
      {error && (
        <div className="text-red-600 ml-4 text-xs px-2 -bottom-1 bg-white rounded absolute">
          {error}
        </div>
      )}
    </div>
  );
}

const randomId = () => {
  const rnd = Math.round(Math.random() * 100000).toString();
  return `id-${rnd}`;
};
